import { Pipe, PipeTransform } from '@angular/core';
import { ValueOption } from '../../../components/list-value-selector/list-value-selector.component';

@Pipe({ name: 'filter' })
export class FilterPipe implements PipeTransform {
  transform(items: ValueOption[], searchText: string, fields?: string | string[]): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();

    return items.filter(it => {
      if (fields) {
        return this.fieldFilter(it, searchText, fields);
      }

      // Workaround for dealing with ListValueSelectorComponent translations
      if (it.displayText !== undefined) {
        return it.displayText.toLocaleLowerCase().includes(searchText);
      }
      return it.displayText.toLocaleLowerCase().includes(searchText);
    });
  }

  private fieldFilter(item: ValueOption, searchText: string, fields: string | string[]): boolean {
    if (Array.isArray(fields)) {
      return fields.some((field: string) => this.includesFieldValue(item, searchText, field));
    }

    return this.includesFieldValue(item, searchText, fields);
  }

  private includesFieldValue(item: ValueOption, searchText: string, field: string): boolean {
    const fieldValue: string | undefined = this.findFieldValue(item, field);

    if (fieldValue === undefined) {
      return false;
    } 

    return fieldValue.toLocaleLowerCase().includes(searchText);
  }

  private findFieldValue(item: any, field: string): string | undefined {
    let value: string | undefined;

    if (!item) {
      return undefined;
    }

    if (Object.keys(item).length === 0 || typeof item === "string") {
      return undefined;
    }

    for (const prop in item) {
      if (prop === field) {
        return item[prop];
      }

      // Check the nested items for this specific field
      value = this.findFieldValue(item[prop], field);

      if (value !== undefined) {
        break;
      }
    }

    return value;
  }
}